/* eslint-disable react/self-closing-comp */
/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable no-case-declarations */
import React, { useState, useRef, useEffect,Suspense } from 'react';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import i18n, { changeLanguage, getLanguages } from '../../i18n'

import { MailIcon, WhatsAppIcon, PMZoneLogo } from '../../Constants/assets';


const InnerContainer = styled.div`
    display: flex;
    height: 100%;
    min-height: 300px;
    width: 100%;
    font-size: 0.875rem;
    flex-direction: column;
    justify-content: center;
`;
const RightSideContainer = styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    width: 35%;

    @media only screen and (max-width: 1150px) {
        & {
            flex: 1;
        }
    }
`;
const ContentContainer = styled.div`
    width: 360px;
    height: 75%;
    place-self: center;
    align-text:center;
    margin-top: 10vh;
`;
const HeaderContainer = styled.div`
    margin-top: 4vh;
    height: 135px;
    align-text: center;
`;
const Title = styled.div`
    font-size: 2.625rem;
`;
const Paragraph = styled.div`
    color: ${props => props.theme.colors.gray};
`;
const FormContainer = styled.div`
    text-align:center;
    display:block;
`;

const ParagraphText = styled.div`
    font-weight: 500;
    font-size: 16px;
    text-align: left;
    margin-left: 2.5rem;
    color: ${props => props.theme.colors.black};
`;

const ButtonInput = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: ${props => props.theme.colors.white};
    background: ${props => props.theme.colors.darkGreen};
    border-radius: 4px;
    width: 18.75rem;
    height: 3.125rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    :active {
        background: ${props => props.theme.colors.lightGray};
    }
    ${props =>
        props.clickedLogin
            ? css`
                  background: ${componentProps => componentProps.theme.colors.lightGray};
              `
            : css`
                  background: ${componentProps => componentProps.theme.colors.darkGreen};
                  cursor: pointer;
              `}
`;


export default function MobileMessage() {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const url = window.location.href;
    const [translationsLoaded, setTranslationsLoaded] = useState(false);
    const [languages, setLanguages] = useState([]);
    useEffect(() => {
        const fetchLanguages = async () => {
          const translationsData = await getLanguages();
    
          const languagesList = Object.values(translationsData);
    
          setLanguages(languagesList);
        };
    
        fetchLanguages();
      }, []);
    useEffect(() => {
        setTimeout(() => {
            setTranslationsLoaded(true);
        }, 250);
    }, []);
    const { t } = useTranslation()

const mailBody = ()=>{
    return `Do you like to play?\nWant to learn project management?\nAre you ready for the challenge?\nClick to play the PMzone Digital Simulation Board Game: ${url}`;
}
    return (
        <Suspense fallback={<div>Loading...</div>}>
        {translationsLoaded && (
        <InnerContainer  >
            <ContentContainer style={{width: (width * 0.9)}}>
                <div>
                    <PMZoneLogo />
                </div>
                <HeaderContainer>
                    <Title> {t('small_screen_login.small_screen_login_title')} </Title>
                    <Paragraph dangerouslySetInnerHTML={{__html: t('small_screen_login.small_screen_login_subtitle').replace(/\n/g, '<br/>')}}>
                    </Paragraph>
                </HeaderContainer>
            </ContentContainer>
            <ContentContainer >
                <FormContainer
                    style={{
                        position:'absolute',
                        bottom: (height * 0.20),
                        left: "5%"
                        
                    }}
                >
                    <ButtonInput 
                        onClick={ ()=>{ window.location = `whatsapp://send?text=Click to play the PMzone Digital Simulation Board Game: ${url} ` }}
                    >
                        {t('small_screen_login.whatsapp_button')}  &nbsp; <WhatsAppIcon style={{height:'30px', width:'30px'}} />
                    </ButtonInput>
                    <ButtonInput 
                        style ={{ 
                            marginTop:'1vh',
                        }}
                        onClick={ ()=>{ window.location=`mailto:?subject=Play%20the%20PMzone%20Digital%20Simulation%20Board%20Game
                                        &body=${encodeURI(mailBody())}` }}
                                        // &body=${encodeURI(mailBody())}` }}
                    >
                        {t('small_screen_login.mail_button')} &nbsp; <MailIcon/>
                    </ButtonInput>
                </FormContainer>
            </ContentContainer>
        </InnerContainer>
        )}
        </Suspense>
    );
}
